import { render, staticRenderFns } from "./FavoriteImportModal.vue?vue&type=template&id=128efec4&scoped=true&"
import script from "./FavoriteImportModal.vue?vue&type=script&lang=ts&"
export * from "./FavoriteImportModal.vue?vue&type=script&lang=ts&"
import style0 from "./FavoriteImportModal.vue?vue&type=style&index=0&id=128efec4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128efec4",
  null
  
)

export default component.exports